// Copy for the EA landing page (Phase 2 task 2.4). The landing leads on
// cross-principal alerts: plans awaiting approval, follow-ups due today,
// focus-defence alerts, and a preview of each principal's next meeting.

export const eaLandingCopy = {
  // Page framing
  pageHeading: "Today's workload",
  pageSubheading: 'The state of every executive you support, in one place.',

  // Section headings
  awaitingApprovalHeading: 'Awaiting approval',
  followUpsHeading: 'Follow-ups due today',
  focusDefenceHeading: 'Focus-defence alerts',
  briefingPackHeading: 'Next meetings',

  // Awaiting approval card
  awaitingApprovalEmpty: 'No plans or decisions are waiting on a principal right now.',
  awaitingApprovalPlan: 'Plan proposed',
  awaitingApprovalDecision: 'Decision to resolve',
  openPrincipalView: "Open principal's plan",

  // Follow-ups card
  followUpsEmpty: 'No follow-ups are due today across your principals.',
  followUpChasing: 'Chasing {name}',
  followUpSince: 'Open since {date}',
  openFollowUp: 'Open in Work Items',

  // Focus-defence card
  focusDefenceEmpty: 'No conflicts on protected focus time today.',
  focusDefenceHard: 'Hard conflict',
  focusDefenceSoft: 'Soft conflict',
  openFocusGrid: 'Open Focus Time',

  // Briefing pack card
  briefingPackEmpty: 'No meetings scheduled for the rest of today.',
  briefingPackOpenPrep: 'Open meeting prep',
  briefingPackNoUpcoming: 'No upcoming meeting',

  // Switching principal
  actingOnBehalf: 'Acting on behalf of {name}',
  switchedTo: 'Switched to {name}',

  // Generic
  viewEaWorkspace: 'Open full workspace',
  loadingPrincipal: 'Loading data…',
  loadError: 'Could not load this section. Refresh to retry.',
} as const;
